import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap-css-only/css/bootstrap.min.css'
import { createBrowserHistory } from 'history'
import 'mdbreact/dist/css/mdb.css'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import 'typeface-ibm-plex-sans'
import Main from './main.js'
import reportWebVitals from './reportWebVitals'
import configureStore from './store/configureStore'
import './styles/style.scss'

const history = createBrowserHistory()
const initialState = window.INITIAL_REDUX_STATE
const store = configureStore(history, initialState)

if (process.env.REACT_APP_BUILD == 'prod') {
    console.log = () => { }
}

// Load plugin script synchronously
function loadPluginScript() {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://duhkahawczku4.cloudfront.net/uhf/${process.env.REACT_APP_BUILD}/current/plugin.iife.js`;
    script.async = false; // Load synchronously
    script.type = 'text/javascript';
    
    script.onload = () => {
      console.log('✓ Plugin script loaded');
      
      // Give it a moment to execute
      setTimeout(() => {
        console.log('=== CHECKING PLUGIN AVAILABILITY ===');
        console.log('typeof window.loadCommonPluginScreen:', typeof window.loadCommonPluginScreen);
        
        // Log ALL window properties
        const allKeys = Object.keys(window);
        console.log('Total window properties:', allKeys.length);
        
        // Look for anything that looks like a function
        const functions = allKeys.filter(key => typeof window[key] === 'function');
        console.log('Functions on window:', functions.length);
        console.log('Sample functions:', functions.slice(0, 20));
        
        // Look for objects that might contain the plugin
        const objects = allKeys.filter(key => typeof window[key] === 'object' && window[key] !== null);
        console.log('Objects on window:', objects.length);
        
        // Check specific namespaces
        if (window.uhf) {
          console.log('window.uhf exists:', Object.keys(window.uhf));
        }
        if (window.commonPlugin) {
          console.log('window.commonPlugin exists:', Object.keys(window.commonPlugin));
        }
        if (window.UHF) {
          console.log('window.UHF exists:', Object.keys(window.UHF));
        }
        
        // Check if function exists under different names
        const possibleFunctionNames = [
          'loadCommonPluginScreen',
          'loadProfileSettings',
          'openProfileSettings',
          'showProfileSettings',
          'initProfileSettings',
          'openCommonPlugin',
          'loadPlugin'
        ];
        
        console.log('Checking for possible function names:');
        possibleFunctionNames.forEach(name => {
          if (typeof window[name] === 'function') {
            console.log(`✓ Found: window.${name}`);
            window.pluginFunctionName = name;
          }
        });
        
        resolve();
      }, 1000);
    };
    
    script.onerror = () => {
      console.error('✗ Failed to load plugin script');
      reject(new Error('Plugin script failed to load'));
    };
    
    document.head.appendChild(script);
  });
}

// Load plugin then render React
loadPluginScript()
  .then(() => {
    console.log('Plugin loaded, rendering React app');
    ReactDOM.render(<Main store={store} history={history} />, document.getElementById('root'));
  })
  .catch(err => {
    console.error('Failed to load plugin, rendering without it:', err);
    ReactDOM.render(<Main store={store} history={history} />, document.getElementById('root'));
  });

reportWebVitals();